import "flatpickr/dist/themes/material_blue.css";
import "../../assets/scss/datatables.scss";

import * as confirmAction from "../../store/confirm/action";
import * as loadingAction from "../../store/loading/action";
import * as messageAction from "../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
  Table,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../components/Custom/ConfirmDialog";
import {
  GET_ALLOCATE_CONF,
  GET_RP_SUMMARY_REPORT,
  PUBLIC_ALLOCATE_SUMMARY_REPORT,
  PUBLIC_SUMMARY_REPORT,
  SAVE_RP_AVG_DEMAND_EVENT,
  SAVE_RP_BALANCE,
  SAVE_RP_BALANCE_EVENT,
  SAVE_RP_FUEL_CONSUMPTION,
  SAVE_RP_QUALITY,
} from "./../../helpers/url_api_constant";
import { Link, useHistory } from "react-router-dom";
import MessageDialog, {
  useModalShowMessage,
} from "../../components/Custom/MessageDialog";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../helpers/auth_helper";

import Flatpickr from "react-flatpickr";
import PropTypes from "prop-types";
import SectionAlarm from "../SummaryReport/SectionAlarm/index";
import SectionBalancing from "../SummaryReport/SectionBalancing/index";
import SectionCompressorFuel from "../SummaryReport/SectionCompressorFuel/index";
import SectionQuality from "../SummaryReport/SectionQuality/index";
import SectionSectionCapacity from "./SectionCapacity/index";
import SectionSystemEntry from "./SessionSystemEntry/index";
import SectionTodayGasPlan from "../SummaryReport/SectionTodayGasPlan/index";
import Select from "react-select";
import moment from "moment";
import { post } from "./../../helpers/api_helper";
import { withTranslation } from "react-i18next";

//i18n

function SummaryReport(props) {

  let history = useHistory();

  const permission = getPermission();
  const dispatch = useDispatch();
  const summaryReportReducer = useSelector(reducer => reducer.SummaryReport);
  const searchObj = {
    DATE: moment().format("YYYY-MM-DD"),
    SELECT_DATE: new Date(),
  };

  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();

  const [searchModel, setSearchModel] = useState(searchObj);

  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  const [oneDayAllocate, setOneDayAllocate] = useState(null);
  const [threeDayAllocate, setThreeDayAllocate] = useState(null);

  const [listRevision, setListRevision] = useState([]);
  const [summaryReportPid, setSummaryReportPid] = useState("");
  const [summaryReportCanSave, setSummaryReportCanSave] = useState(false);
  const [canPublicAllowcation, setCanPublicAllowcation] = useState(false);
  // DropDown
  const [dropDownRevision, setDropDownRevision] = useState(listRevision[0]);
  // DropDown

  // Handle Set Value DropDown//
  const handleSelectDropDownRevision = selected => {
    setDropDownRevision(selected);
    setSummaryReportPid(selected.value);
    if (selected.label.trim() == "Changed") {
      setSummaryReportCanSave(true);
    } else {
      setSummaryReportCanSave(false);
    }
  };
  // Handle Set Value DropDown Search //

  useEffect(
    function () {
      getSummyReport();
      fetchData();
    },
    [searchModel.SELECT_DATE]
  );
  useEffect(
    function () {
      checkCanPublicAllocate();
    },
    [summaryReportPid, listRevision]
  );

  // useEffect(() => {
  //   console.log(oneDayAllocate);
  // }, [oneDayAllocate])

  // useEffect(() => {
  //   console.log(threeDayAllocate);
  // }, [threeDayAllocate])

  const fetchData = async () => {
    dispatch(loadingAction.showLoading());
    // console.log(searchModel);
    try {
      let [
        allocateOneDay,
        allocateThreeDay,
      ] = await Promise.all([
        post(GET_ALLOCATE_CONF, {
          UPLOAD_START: moment(searchModel.SELECT_DATE).add(-1, "day").format("YYYY-MM-DD"),
          UPLOAD_TO: moment(searchModel.SELECT_DATE).add(-1, "day").format("YYYY-MM-DD"), STATUS_FLAG: 1
        }),
        post(GET_ALLOCATE_CONF, {
          UPLOAD_START: moment(searchModel.SELECT_DATE).add(-4, "day").format("YYYY-MM-DD"),
          UPLOAD_TO: moment(searchModel.SELECT_DATE).add(-4, "day").format("YYYY-MM-DD"), STATUS_FLAG: 1
        }),
      ])
      // console.log(allocateOneDay);
      // console.log(allocateThreeDay);
      if (allocateOneDay.data.allocateConfList.length > 0) {
        setOneDayAllocate(allocateOneDay.data.allocateConfList[0]);
      } else {
        setOneDayAllocate(null)
      }
      if (allocateThreeDay.data.allocateConfList.length > 0) {
        setThreeDayAllocate(allocateThreeDay.data.allocateConfList[0]);
      } else {
        setThreeDayAllocate(null)
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const checkCanPublicAllocate = () => {
    setCanPublicAllowcation(false);
    let objSummaryReport = listRevision.find(
      row => row.value == summaryReportPid
    );
    // let listPublicRev = listRevision;
    let listPublicRev = listRevision.filter(row => row.PRIORITY_FLAG != 99);
    listPublicRev = listPublicRev.sort(function (a, b) {
      return b.PRIORITY_FLAG - a.PRIORITY_FLAG;
    });

    if (objSummaryReport && objSummaryReport.PRIORITY_FLAG != 99) {
      if (objSummaryReport.value == listPublicRev[0].value) {
        setCanPublicAllowcation(true);
      }
      // console.log(objSummaryReport)
    }
  };
  useEffect(
    function () {
      if (listRevision.length > 0) {
        let listRevistionData = listRevision.sort(function (a, b) {
          return b.PRIORITY_FLAG - a.PRIORITY_FLAG;
        })[0];
        setSummaryReportPid(listRevistionData.value);
        setDropDownRevision(listRevistionData);
        if (listRevistionData.label.trim() == "Changed") {
          setSummaryReportCanSave(true);
        } else {
          setSummaryReportCanSave(false);
        }
      } else {
        setSummaryReportCanSave(false);
        setDropDownRevision(null);
        setSummaryReportPid(null);
      }
    },

    [listRevision]
  );

  // onInit//
  const getSummyReport = async () => {
    let data = await post(GET_RP_SUMMARY_REPORT, {
      SUMMARYREPORT_DATE: moment(searchModel.SELECT_DATE)
        .add(-1, "day")
        .format("YYYY-MM-DD"),
    });

    setListRevision(
      data.data.rpSummaryReportList.map(row => ({
        label: row.SUMMARYREPORT_REV + (row.SUMMARYREPORT_DESC != "" && row.SUMMARYREPORT_DESC != null ? " - " + row.SUMMARYREPORT_DESC : ""),
        value: row.PID,
        PRIORITY_FLAG: row.PRIORITY_FLAG,
        SUMMARYREPORT_DATE: row.SUMMARYREPORT_DATE,
      }))
    );
  };
  //Function CURL

  useEffect(() => {
    // console.log(summaryReportReducer);
  }, [summaryReportReducer]);

  const validateForm = () => {
    let bResult = true;
    // console.log(summaryReportReducer.fuelConsumption);
    if (
      summaryReportReducer.fuelConsumption.VALIDATE_FLAG == true &&
      summaryReportReducer.fuelConsumption.CAUSE_REMARK == ""
    ) {
      // alert("test");
      bResult = false;
    }

    return bResult;
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }
  const handlerSaveSummaryReport = async (publicMode = false) => {
    // console.log(summaryReportReducer.quality);
    // console.log(summaryReportReducer.avgDemandEvent);
    dispatch(loadingAction.showLoading());
    try {
      if (validateForm()) {

        let [
          avgDemandEvent,
          quality,
          balancing,
          offshoreBalancing,
          fuelConsumption,
        ] = await Promise.all([
          post(SAVE_RP_AVG_DEMAND_EVENT, summaryReportReducer.avgDemandEvent),
          post(SAVE_RP_QUALITY, summaryReportReducer.quality),
          post(SAVE_RP_BALANCE, summaryReportReducer.balancing),
          post(SAVE_RP_BALANCE_EVENT, summaryReportReducer.offshoreBalancing),
          post(SAVE_RP_FUEL_CONSUMPTION, summaryReportReducer.fuelConsumption),
        ]);
        if (avgDemandEvent.resultCode != 200) {
          dispatch(messageAction.showMessage(avgDemandEvent.resultDescription));
        } else if (quality.resultCode != 200) {
          dispatch(messageAction.showMessage(quality.resultDescription));
        } else if (balancing.resultCode != 200) {
          dispatch(messageAction.showMessage(balancing.resultDescription));
        } else if (offshoreBalancing.resultCode != 200) {
          dispatch(
            messageAction.showMessage(offshoreBalancing.resultDescription)
          );
        } else if (fuelConsumption.resultCode != 200) {
          dispatch(
            messageAction.showMessage(fuelConsumption.resultDescription)
          );
        } else {
          if (publicMode) {
            let res = await publicSummaryReport();
            if (res.resultCode == 200) {
              getSummyReport();
              dispatch(messageAction.showMessage("Public success."));
            } else {
              dispatch(messageAction.showMessage(res.resultDescription));
            }
          } else {
            dispatch(messageAction.showMessage("Save success."));
          }
        }
      } else {
        dispatch(
          messageAction.showMessage(
            "Please key cause in compressor fuel consumption"
          )
        );
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const publicSummaryReport = () =>
    post(PUBLIC_SUMMARY_REPORT, { PID: summaryReportPid });

  const publicFinalAllowcation = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(PUBLIC_ALLOCATE_SUMMARY_REPORT, {
        SUMMARYREPORT_DATE: moment(searchModel.SELECT_DATE)
          .add(-1, "day")
          .format("YYYY-MM-DD"),
      });
      if (res.resultCode == 200) {
        getSummyReport();

        dispatch(messageAction.showMessage("Public success."));
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const publicAndPublicFinalAllowcation = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let [res1, res2] = await Promise.all([post(PUBLIC_SUMMARY_REPORT, { PID: summaryReportPid }), post(PUBLIC_ALLOCATE_SUMMARY_REPORT, {
        SUMMARYREPORT_DATE: moment(searchModel.SELECT_DATE)
          .add(-4, "day")
          .format("YYYY-MM-DD"),
      })]);
      if (res1.resultCode == 200) {
        getSummyReport();

        dispatch(messageAction.showMessage("Public success."));
      } else {
        dispatch(messageAction.showMessage(res1.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  return (
    <React.Fragment>
      <div className="page-content pb-2">
        <Container fluid>
          <Row>
            <Col xl="12">
              {/* <Card className="mb-1">
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Summary Report")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Summary Report
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card> */}

              <Card className="mb-1" style={{ backgroundColor: "#001fff1f" }}>
                <CardBody>
                  <Col sm="12">
                    <FormGroup className="row align-items-center">
                      <Col sm="4">
                        <h1 className="mb-sm-0 font-size-20">
                          {props.t("Summary Report")}
                        </h1>
                      </Col>
                      <Col
                        sm="1"
                        className="d-flex justify-content-end"
                      >
                        <Label>Date :</Label>
                      </Col>
                      <Col
                        sm="3"
                        className="justify-content-start"
                      >
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="Select Date"
                          options={{
                            altInput: true,
                            altFormat: "d/m/Y",
                            // altFormat: "F Y",
                            dateFormat: "d/m/Y",
                            maxDate: new Date(),
                          }}
                          onChange={value => {
                            // setTempSearch({
                            //   ...tempSearch,
                            //   SELECT_DATE: value[0],
                            // });
                            setSearchModel({
                              ...searchModel,
                              SELECT_DATE: value[0],
                              DATE: moment(value[0]).format("YYYY-MM-DD"),
                              // SELECT_DATE: moment(value[0].setDate(value[0].getDate() - 1)).format("YYYY-MM-DD")
                            });
                          }}
                          value={searchModel.SELECT_DATE}
                        // value={new Date()}
                        />
                      </Col>
                      <Col
                        sm="1"
                        className="d-flex justify-content-end"
                      >
                        <Label>Revision :</Label>
                      </Col>

                      <Col sm="3" className="justify-content-start">
                        <Select
                          // placeholder="All"
                          // isClearable={true}
                          value={dropDownRevision}
                          onChange={handleSelectDropDownRevision}
                          options={listRevision}
                          classNamePrefix="select2-selection"
                          styles={SelectStyle}
                        />
                      </Col>
                    </FormGroup>
                  </Col>

                </CardBody>
              </Card>

              <SectionSystemEntry
                date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                summaryReportPid={summaryReportPid}
              />

              <SectionBalancing
                date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                summaryReportPid={summaryReportPid}
              />

              <SectionSectionCapacity
                date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                summaryReportPid={summaryReportPid}
              />

              <SectionQuality
                date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                summaryReportPid={summaryReportPid}
              />

              <SectionCompressorFuel
                date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                summaryReportPid={summaryReportPid}
              />

              <SectionAlarm
                date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                summaryReportPid={summaryReportPid}
              />

              <SectionTodayGasPlan
                data={searchModel.SELECT_DATE}
                summaryReportPid={summaryReportPid}
              />

              {summaryReportPid  && !canPublicAllowcation &&(
                <Row>
                  <Col sm="12">
                    <Card  className="mb-1" style={{ backgroundColor: "#001fff1f" }}>
                      <CardBody>
                        <Row>
                          <Col
                            sm="12"
                            className="d-flex align-items-center justify-content-end"
                          >
                            <div className="d-grid gap-2 d-md-block">
                              {permission.eSRT  && (
                                <>
                                  <Button
                                    onClick={() =>
                                      handlerSaveSummaryReport(false)
                                    }
                                    color="success"
                                    className="btn w-md ms-2"
                                  >
                                    <i className="bx bx-save"> </i> &nbsp; Save
                                  </Button>


                                </>
                              )}
                              {permission.eSRT && summaryReportCanSave && (
                                <>
                                

                                  <Button
                                    onClick={() => handlerSaveSummaryReport(true)}
                                    color="primary"
                                    className="btn w-md ms-2"
                                  >
                                    <i className="bx bxs-report"> </i> &nbsp;
                                    Public Report
                                  </Button>
                                </>
                              )}
                              {permission.eSRT &&summaryReportCanSave&& (
                                <>
                                  <Button
                                    // onClick={() => publicAndPublicFinalAllowcation()}
                                    onClick={() => {
                                      dispatch(
                                        confirmAction.showConfirm(
                                          threeDayAllocate != null ? "ใช้ไฟล์ " + threeDayAllocate.UPLOAD_FILE + "ในการ Final Allocation ยืนยันหรือไม่ ?"
                                            : "ไม่พบไฟล์ Allocation Data ของวันที่ " + moment(searchModel.SELECT_DATE).add(-4, "day").format("DD/MM/YYYY") + " ต้องการดำเนินการต่อหรือไม่ ?",
                                          () => {
                                            publicAndPublicFinalAllowcation()
                                          }
                                        )
                                      );
                                    }}
                                    color="primary"
                                    className="btn w-md ms-2"
                                  >
                                    <i className="bx bxs-report"> </i> &nbsp;
                                    Public And Final Allocation D-3
                                  </Button>
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
          
              {canPublicAllowcation && (
                <Row>
                  <Col sm="12">
                    <Card style={{ backgroundColor: "#001fff1f" }}>
                      <CardBody>
                        <Row>
                          <Col
                            sm="12"
                            className="d-flex align-items-center justify-content-end"
                          >
                            <div className="d-grid gap-2 d-md-block">
                              {permission.eSRT && (
                                <>
                                <Button
                                    onClick={() =>
                                      handlerSaveSummaryReport(false)
                                    }
                                    color="success"
                                    className="btn w-md ms-2"
                                  >
                                    <i className="bx bx-save"> </i> &nbsp; Save
                                  </Button>
                                  <Button
                                    // onClick={() => publicFinalAllowcation()}
                                    onClick={() => {
                                      dispatch(
                                        confirmAction.showConfirm(
                                          oneDayAllocate != null ? "ใช้ไฟล์ " + oneDayAllocate.UPLOAD_FILE + " ในการ Final Allocation ยืนยันหรือไม่ ?"
                                            : "ไม่พบไฟล์ Allocation Data ของวันนี้ต้องการดำเนินการต่อหรือไม่ ?",
                                          () => {
                                            publicFinalAllowcation()
                                          }
                                        )
                                      );
                                    }}
                                    color="primary"
                                    className="btn w-md ms-2"
                                  >
                                    <i className="bx bxs-report"> </i> &nbsp;
                                    Public Final Allocation
                                  </Button>
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Container>

        {/* MessageDialog */}
        <MessageDialog
          isOpen={showMessage}
          hide={toggleModalMessage}
          title={titleMessageModal}
          message={bodyMessageModal}
        />
        {/* comfirmDialog */}
        <ConfirmDialog
          isOpen={showConfirm}
          hide={toggleConfirm}
          message={messageConfirm}
        // onConfirm={deleteData}
        />
      </div>
    </React.Fragment>
  );
}

SummaryReport.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ SummaryReport }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SummaryReport));
